import Netflix from '../../Assets/Netflix.jpg'
import Google from '../../Assets/Google.png'

export const projectData = [
{
    id: 1,
    image: Netflix,
    title: 'Netflix Clone',
    category: 'Web',
    proyect: 'https://netflixclonev2tadeo.netlify.app',
    github: 'https://github.com/WatchMakker/NetflixClone'
},
{
    id: 2,
    image: Google,
    title: 'Google Clone',
    category: 'Web',
    proyect: 'https://google-tadeo-v1.netlify.app',
    github: 'https://github.com/WatchMakker/Google_clone'
}]

export const proyectsNav = [
    {
        name:"All"
    },
    {
        name:'Web'
    },
    
]